// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__CuAe9","Success":"Button__Success__2-viV","Danger":"Button__Danger__NGUBL","Info":"Button__Info__8itUC"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Button/Button.css
// module id = 143
// module chunks = 0